import { useState, useEffect } from 'react';
import { getBezierPath, EdgeLabelRenderer, BaseEdge, type EdgeProps } from '@xyflow/react';
import { useNodesEdges } from '../../contexts/useNodesEdges';

const ConditionEdge = ({
    id,
    label,
    sourceX,
    sourceY,
    source,
    target,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    selected,
}: EdgeProps) => {
    const { flowOrder, setEdges } = useNodesEdges();
    const [hovered, setHovered] = useState(false);
    const [path] = getBezierPath({
        sourceX,
        sourceY: sourceY - 10,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    const showLabels = hovered || selected;
    const edgeSource = flowOrder.find((item) => item.id === source)?.number ?? '';
    const edgeTarget = flowOrder.find((item) => item.id === target)?.number ?? '';

    useEffect(() => {
        if (selected) {
            setEdges((edges) => {
                const idx = edges.findIndex((e) => e.id === id);
                if (idx === -1) {
                    return edges;
                } else {
                    const edge = edges[idx];
                    const newEdges = [...edges.slice(0, idx), ...edges.slice(idx + 1), edge];
                    return newEdges;
                }
            });
        }
    }, [selected, setEdges, id]);

    return (
        <>
            <g onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
                <BaseEdge id={id} path={path} interactionWidth={50} />
            </g>
            <EdgeLabelRenderer>
                {showLabels && (
                    <div
                        className={`edge-label ${selected ? 'selected' : ''}`}
                        style={{
                            transform: `translate(-50%, 25%) translate(${
                                sourceX + 0.0225 * (targetX - sourceX)
                            }px,${sourceY}px)`,
                        }}>
                        <div>Target: {edgeTarget}</div>
                    </div>
                )}
            </EdgeLabelRenderer>
            <EdgeLabelRenderer>
                {showLabels && (
                    <div
                        className={`edge-label ${selected ? 'selected' : ''}`}
                        style={{
                            transform: `translate(-50%, -125%) translate(${
                                targetX + 0.0225 * (sourceX - targetX)
                            }px,${targetY}px)`,
                        }}>
                        <div>Source: {edgeSource}</div>
                        <div>{label}</div>
                    </div>
                )}
            </EdgeLabelRenderer>
        </>
    );
};

export default ConditionEdge;
